import { defineMessages } from 'react-intl';
import type { NoMessageValues, MessageValue } from 'react-intl';

export const productCategoryNavigationMobileV2Messages = defineMessages<{
  readonly header: NoMessageValues;
  readonly allCategories: NoMessageValues;
  readonly previousCategory: { readonly name: MessageValue };
  readonly allIn: { readonly name: MessageValue };
  readonly helperSingle: NoMessageValues;
  readonly submit: NoMessageValues;
  readonly cancel: NoMessageValues;
  readonly drillIntoCategory: { readonly name: MessageValue };
}>({
  header: {
    id: 'filtersV2.category.navigation.header',
    defaultMessage: 'Kategorie',
  },
  allCategories: {
    id: 'filtersV2.category.navigation.allCategories',
    defaultMessage: 'Alle Kategorien',
  },
  previousCategory: {
    id: 'filtersV2.category.navigation.previousCategory',
    defaultMessage: 'Vorherige Kategorie: {name}',
  },
  allIn: {
    id: 'filtersV2.category.navigation.allIn',
    defaultMessage: 'Alles in {name}',
  },
  helperSingle: {
    id: 'filtersV2.category.navigation.helperSingle',
    defaultMessage: 'Du kannst hier nur eine Auswahlmöglichkeit treffen.',
  },
  submit: {
    id: 'filtersV2.category.navigation.submit',
    defaultMessage: 'Übernehmen',
  },
  cancel: {
    id: 'filtersV2.category.navigation.cancel',
    defaultMessage: 'Abbrechen',
  },
  drillIntoCategory: {
    id: 'filtersV2.category.navigation.drillIntoCategory',
    defaultMessage: 'Unterkategorien von {name} anzeigen',
  },
});
